const message = {
    messageData: null,
    messageFilterData: null,
    httpStatusCode: {
        unauthorized: 401
    },
    storage: {
        messageId: 'messageid'
    },
    status: {
        read: 'vds-table__data--read',
        unread: 'vds-table__data--unread'
    },
    popup: {
        subject: '#messages-modal-subject',
        sentDate: '#messages-modal-date'
    },
    element: {
        attachment: '.attachment',
        messsageRow: '.messagerow',
        table: {
            body: '#message-table-body'
        },
        filter: {
            sortable: '#date-header-sortable',
            yearDropDown: '#messages-year-dropdown',
            yearDropDownOptionSelected: '#messages-year-dropdown option:selected',
            select: '.vds-table__header-text--sortable-reverse'
        }
    },
    pagination: {
        innerHtml: '.vds-pagination__inner',
        item: {
            total: '.pagination_total_item'
        },
        dropDown: {
            items: '.vds-pagination__toggle--items .vds-form__custom-select',
            pages: '.vds-pagination__toggle--pages .vds-form__custom-select'
        },
        pageNumber: {
            current: '.pagination_current_page_number',
            total: '.pagination_total_page_number',
            selected: '.pagination_selected_page_number'
        },
        button: {
            disabled: 'vds-pagination__page-toggle--disabled',
            nextPage: '.vds-pagination__page-toggle--next',
            previous: '.vds-pagination__page-toggle--previous'
        },
        pageSize: '.pagination_current_item_size'
    },
    init: function () {
        message.getUserMessages();
    },
    bindModelPopupEvents: function () {
        $(message.element.attachment).on('click', message.messageAttachmentClick);
    },
    bindDynamicElementEvent: function () {
        $(message.element.messsageRow).on('click', message.messageRowClick);
    },
    bindEvent: function () {
        message.bindDynamicElementEvent();
        $(message.element.filter.yearDropDown).on('change', message.filterYearOnChange);
        $(message.element.filter.sortable).on('click', message.sortOrderChange);
        $(message.pagination.dropDown.items).on('change', message.pageSizeOnChange);
        $(message.pagination.button.previous).on('click', message.openPreviousPage);
        $(message.pagination.button.nextPage).on('click', message.openNextPage);
        $(message.pagination.dropDown.pages).on('change', message.pageNumberOnChange);
    },
    getUserMessages: function () {
        jQuery.ajax({
            type: 'GET',
            url: '/api/sitecore/Message/MyMessages',
            contentType: 'application/json',
            dataType: 'json',
            async: false
        })
            .then(message.processMessages)
            .then(message.loadPreCached)
            .then((id) => id && message.loadMessageById(id))
            .catch(message.ajaxFailure);
    },
    processMessages: function (data) {
        message.messageData = data.messages;
        message.messageFilterData = message.messageData;
        const result = data.messageFilterYears;
        let seloption = "";
        $.each(result, function (i) {
            seloption += '<option value="' + result[i] + '">' + result[i] + '</option>';
        });

        $('#messages-year-dropdown').append(seloption);
        message.bindEvent();
        const currentPageSize = message.getCurrentPageSize(message.messageFilterData);
        const currentPageNumber = message.getCurrentPageNumber();
        message.showTable(currentPageNumber, currentPageSize);
        message.setTotalItems(message.messageFilterData.length);
        message.setTable(currentPageSize);
    },
    loadPreCached: function () {
        let messageId = sessionStorage.getItem(message.storage.messageId);
        sessionStorage.removeItem(message.storage.messageId);
        return messageId;
    },
    ajaxFailure: function (jqXHR) {
        // Timeout
        if (jqXHR.status === message.httpStatusCode.unauthorized) {
            // Force login
            window.location.reload();
        } else {
            window.location.replace('/error/error-page');
        }
    },
    loadMessageDetails: function (messageId) {
        sessionStorage.setItem(message.storage.messageId, messageId);
        jQuery.ajax({
            type: 'GET',
            url: '/api/sitecore/Message/GetMessageAttachments?messageId=' + messageId,
            contentType: 'application/json',
            dataType: 'json'
        })
            .then(message.loadMessageDetailsSuccess)
            .catch(message.ajaxFailure);
    },
    loadMessageDetailsSuccess: function (data) {
        sessionStorage.removeItem(message.storage.messageId);
        openModal('my-messages-loading-modal');
        let attachmentLinkListModel = $('#attachment-links-section').html();
        let attachmentLinkList = '';
        let loadingLinkModel = $('#attachment-link').html();
        loadingLinkModel = loadingLinkModel.replace('[messageid]', data.messageId);
        for (let i = 0; i < data.messageDetails.length; i++) {
            let attachmentLink = loadingLinkModel;
            attachmentLink = attachmentLink.replace('[attachmentindex]', i);
            attachmentLink = attachmentLink.replace('[attachmentname]', data.messageDetails[i].fileName);
            attachmentLinkList = attachmentLinkList + attachmentLink;
            if (i + 1 !== data.messageDetails.length) {
                attachmentLinkList = attachmentLinkList + '<br>';
            }
        }
        attachmentLinkListModel = attachmentLinkListModel.replace('[attachmentlinks]', attachmentLinkList);
        $('#attachment-location').html(attachmentLinkListModel);
        message.bindModelPopupEvents();
    },
    getMessageStatusClass: function (selectedMessage) {
        if (selectedMessage.isRead) {
            return message.status.read;
        } else {
            return message.status.unread;
        }
    },
    setTable: function (pageSize) {
        $('.pagination_totalitems').text(message.messageData.length);
        $('.selectpageradio').hide();
        let i = 0;
        let pageNo = 0;

        while (i < message.messageFilterData.length) {
            i += Number(pageSize);
            pageNo += Number(1);
            $('#selectpageradio-label-' + pageNo).show();
        }

        message.setCurrentPageNumber(1);
    },
    formatDate: function (inputDate) {
        const today = new Date(inputDate);
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const yyyy = today.getFullYear();

        return dd + '/' + mm + '/' + yyyy;
    },
    loadMessageList: function (currentPageNumber, currentPageSize) {
        const currentPage = message.paginateMessage(message.messageFilterData, currentPageNumber, currentPageSize);
        const messageView = $('#message-template').html();
        let messageList = '';
        let index = 0;
        for (let i = 0; i < currentPage.length; i++) {
            if ($(message.element.filter.select).length > 0) {
                index = currentPage.length - (i + 1);
            } else {
                index = i;
            }
            let messageRow = messageView;
            messageRow = messageRow.replace('[messageid]', currentPage[index].messageId);
            messageRow = messageRow.replace('[status]', message.getMessageStatusClass(currentPage[index]));
            messageRow = messageRow.replace('[date]', message.formatDate(currentPage[index].sentDate));
            messageRow = messageRow.replace('[subject]', message.formatSubject(currentPage[index].subject));

            messageList = messageList + messageRow;
        }

        $(message.element.table.body).html(messageList);
    },
    showTable: function (currentPageNumber, currentPageSize) {
        if (message.messageFilterData !== null) {
            message.loadMessageList(currentPageNumber, currentPageSize);
            const totalPage = message.getTotalPageNumber(message.messageFilterData,
                currentPageSize);
            message.setCurrentPageNumber(currentPageNumber);
            message.setTotalPageNumber(totalPage);
            message.validateNextPageLink(currentPageNumber, totalPage);
            message.validatePreviousPageLink(currentPageNumber);
            message.bindDynamicElementEvent();
        }
    },
    sortOrderChange: function () {
        const currentPageSize = message.getCurrentPageSize(message.messageFilterData);
        const currentPageNumber = message.getCurrentPageNumber();

        message.showTable(currentPageNumber, currentPageSize);
    },
    filterYearOnChange: function () {
        message.filterMessageData();
        message.setTotalItems(message.messageFilterData.length)
        const currentPageSize = message.getCurrentPageSize(message.messageFilterData);
        message.setTable(currentPageSize);
        message.showTable(1, currentPageSize);
    },
    messageAttachmentClick: function () {
        const messageId = $(this).data('messageid');
        const attachmentIndex = $(this).data('attachmentindex');

        window.location = '/api/sitecore/Message/DownloadMessageAttachments?messageId='
            + messageId + '&attachmentIndex=' + attachmentIndex
    },
    messageRowClick: function () {
        const messageId = $(this).data('messageid');
        message.loadMessageById(messageId);
    },
    loadMessageById: function (id) {
        let selected = message.messageData.find(element => element.messageId === id);
        if (selected) {
            message.loadMessageDetails(id);
            selected.isRead = true;
            let selectedListItem = `[data-messageid='${selected.messageId}']`;
            $(selectedListItem).find('.' + message.status.unread).addClass(message.status.read);
            $(selectedListItem).find('.' + message.status.unread).removeClass(message.status.unread);
            $(message.popup.subject).html(message.formatSubject(selected.subject));
            $(message.popup.sentDate).html(message.formatDate(selected.sentDate));
            message.filterMessageData();
        }
    },
    formatSubject: function (subject) {
        if (subject !== null && subject !== undefined) {
            return subject.replace('--', "'");
        } else {
            return '';
        }
    },
    pageNumberOnChange: function () {
        const currentPageSize = message.getCurrentPageSize(message.messageFilterData);
        const currentPageNumber = message.getSelectedPageNumber(this);

        message.showTable(currentPageNumber, currentPageSize);
    },
    pageSizeOnChange: function () {
        const currentPageSize = message.getSelectedPageSize(this, message.messageFilterData);
        message.setTable(currentPageSize);

        const currentPageNumber = 1;

        message.showTable(currentPageNumber, currentPageSize);
    },
    openPreviousPage: function () {
        const currentPageSize = message.getCurrentPageSize(message.messageFilterData);
        const currentPageNumber = message.getCurrentPageNumber();

        const previousPageNumber = Number(currentPageNumber) - 1;
        if (previousPageNumber >= 1) {
            message.showTable(previousPageNumber, currentPageSize);
        }
    },
    openNextPage: function () {
        const currentPageSize = message.getCurrentPageSize(message.messageFilterData);
        const currentPageNumber = message.getCurrentPageNumber();

        const nextPageNumber = Number(currentPageNumber) + 1;
        if (nextPageNumber <= message.getTotalPageNumber(message.messageFilterData,
            currentPageSize)) {
            message.showTable(nextPageNumber, currentPageSize);
        }
    },
    filterMessageData: function () {
        const selectedYear = Number($(message.element.filter.yearDropDownOptionSelected).text());

        if (selectedYear > 0) {
            message.messageFilterData = message.messageData.filter(function (obj) {
                return obj.sentDate.substr(0, 4) === selectedYear.toString();
            });
        } else {
            message.messageFilterData = message.messageData;
        }
    },
    paginateMessage: function (messageList, currentPageNumber, curentPageSize) {
        message.setCurrentPageNumber(currentPageNumber);

        return messageList.slice((currentPageNumber - 1) * curentPageSize, currentPageNumber * curentPageSize);
    },
    getTotalPageNumber: function (messageList, curentPageSize) {
        let i = 0;
        let pageNumber = 0;

        while (i < messageList.length) {
            i += Number(curentPageSize);
            pageNumber += Number(1);
        }

        return pageNumber
    },
    getCurrentPageSize: function (array) {
        let pageSize = array.length;
        if ($(message.pagination.pageSize).children().text() !== 'All') {
            pageSize = $($(message.pagination.pageSize).children()[0]).text();
        }

        return Number(pageSize);
    },
    getCurrentPageNumber: function () {
        return Number($($(message.pagination.pageNumber.current)[0]).text());
    },
    setCurrentPageSize: function (pageSize) {
        message.setElementValue(message.pagination.pageSize, pageSize);
    },
    setCurrentPageNumber: function (pageNumber) {
        $(message.pagination.pageNumber.current).text(pageNumber);
        $($(message.pagination.pageNumber.selected).children()).text(pageNumber);
        const siblingElement = $(message.pagination.pageNumber.selected).siblings();
        $(siblingElement).find('input:radio').prop('checked', false);
        $($(siblingElement).find('#selectdownpageradio-' + pageNumber)[0]).prop('checked', true);
        $($(siblingElement).find('#selectuppageradio-' + pageNumber)[0]).prop('checked', true);
    },
    setTotalPageNumber: function (pageNumber) {
        $(message.pagination.pageNumber.total).text(pageNumber);
    },
    setTotalItems: function (itemsCount) {
        $(message.pagination.item.total).text(itemsCount);
    },
    setElementValue: function (element, value) {
        $(element).data('value', value);
        $(element).children().html(value);
    },
    getSelectedPageSize: function (element, array) {
        let pageSize = $($(element).find(message.pagination.pageSize)).children().text();
        message.setCurrentPageSize(pageSize);

        if ($($(element).find(message.pagination.pageSize)).children().text() === 'All') {
            pageSize = array.length;
        }

        return Number(pageSize);
    },
    getSelectedPageNumber: function (element) {
        const pageNumber = $($(element).find(message.pagination.pageNumber.selected)).children().text();

        return Number(pageNumber);
    },
    validateNextPageLink: function (currentPageNumber, totalPage) {
        if (currentPageNumber >= totalPage) {
            $(message.pagination.button.nextPage).addClass(message.pagination.button.disabled);
        } else {
            $(message.pagination.button.nextPage).removeClass(message.pagination.button.disabled);
        }
    },
    validatePreviousPageLink: function (currentPageNumber) {
        if (currentPageNumber <= 1) {
            $(message.pagination.button.previous).addClass(message.pagination.button.disabled);
        } else {
            $(message.pagination.button.previous).removeClass(message.pagination.button.disabled);
        }
    },
};

if (!String.prototype.padStart) {
    String.prototype.padStart = function padStart(targetLength, padString) {
        targetLength = targetLength >> 0;
        padString = String((typeof padString !== 'undefined' ? padString : ' '));
        if (this.length > targetLength) {
            return String(this);
        }
        else {
            targetLength = targetLength - this.length;
            if (targetLength > padString.length) {
                padString += padString.repeat(targetLength / padString.length);
            }
            return padString.slice(0, targetLength) + String(this);
        }
    };
}
